import { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import { useTheme } from "@mui/material";

export const PieChart_TicketToday = ({ ticketToday = [], datalabels }) => {
  const theme = useTheme();
  const [devices, setDevices] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    const setLocalAgentState = () => {
      if (ticketToday[0]) {
        setDevices([
          {
            title: "Unassign Agent Tickets",
            value: ticketToday[0]["Unassign Agent Tickets"],
            color: "#BA68C8",
          },

          {
            title: "New Tickets",
            value: ticketToday[0]["New Tickets"],
            color: "#FF9800",
          },

          {
            title: "In Progress Tickets",
            value: ticketToday[0]["In Progress Tickets"],
            color: "#FFE200",
          },

          {
            title: "Assigned Department Tickets",
            value: ticketToday[0]["Assigned Department Tickets"],
            color: "#3F80FF",
          },

          {
            title: "Resolved Tickets",
            value: ticketToday[0]["Resolved Tickets"],
            color: "#4CAF50",
          },

          {
            title: "Close Tickets",
            value: ticketToday[0]["Close Tickets"],
            color: "#aaaaaa",
          },
        ]);
      }
    };

    setLocalAgentState();
  }, [ticketToday]);

  useEffect(() => {
    if (devices)
      setData({
        datasets: [
          {
            data: devices.map((x) => x.value),
            backgroundColor: devices.map((x) => x.color),
            borderWidth: 1,
            borderColor: "#FFFFFF",
            hoverBorderColor: "#FFFFFF",

            datalabels: {
              anchor: "center",
              align: "center",
            },
          },
        ],

        labels: devices.map((x) => x.title),
      });
  }, [devices]);

  let final = ticketToday.map((a) =>
    Object.values(a).reduce((b, c) => b + (typeof c === "number" ? c : 0))
  );

  const options = {
    layout: { padding: 0 },

    legend: {
      display: false,
    },

    maintainAspectRatio: false,
    responsive: true,

    tooltips: {
      backgroundColor: theme.palette.background.paper,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: "index",
      titleFontColor: theme.palette.text.primary,
    },

    plugins: {
      datalabels: {
        ...datalabels,
      },
    },
  };

  return (
    <div
      style={{
        height: 380,
        paddingTop: 10,
        position: "relative",
        paddingBottom: 10,
      }}
    >
      {final[0] === 0 ? (
        <div className="DoughnutNoActivity">No Activity</div>
      ) : data ? (
        <Pie data={data} options={options} />
      ) : (
        ""
      )}
    </div>
  );
};
export default PieChart_TicketToday;
